// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0cde5df8","703":"d322a947"}[chunkId] + ".chunk.js";
};